import { option } from "./uiUtils"

export enum TimePeriod {
    TODAY = 'today',
    LAST_7_DAYS = '7-days',
    LAST_14_DAYS = '14-days',
    LAST_30_DAYS = '30-days',
    MANUAL = 'manual'
}

export const timePeriodOptions = () => [
    option(TimePeriod.TODAY, 'Hoy'),
    option(TimePeriod.LAST_7_DAYS, 'Últimos 7 días'),
    option(TimePeriod.LAST_14_DAYS, 'Últimos 14 días'),
    option(TimePeriod.LAST_30_DAYS, 'Últimos 30 días'),
    option(TimePeriod.MANUAL, 'Manual')
]

export const buildDateFrom = (daysBack: number) => {
    const newDateFrom = new Date()
    newDateFrom.setDate(newDateFrom.getDate() - daysBack)
    newDateFrom.setHours(0, 0, 0, 0)
    return newDateFrom
}

export const buildDateTo = () => {
    const newDateTo = new Date()
    newDateTo.setHours(23, 59, 59, 999)
    return newDateTo
}
